import isArrayLike from './is-array-like';
export default function last(o) {
    if (isArrayLike(o)) {
        var arr = o;
        return arr[arr.length - 1];
    }
    return undefined;
}
//# sourceMappingURL=last.js.map